<script setup lang="ts">
defineEmits(["close"]);
const props = defineProps({
  theme: {
    type: String as PropType<"green" | "red" | "yellow" | "readOnly">,
    default: "green",
  },
  dismissible: {
    type: Boolean,
    default: false,
  },
});

const containerClasses = computed(() => {
  if (props.theme === "green") return "bg-ngreen-4";
  if (props.theme === "red" || props.theme === "readOnly") return "bg-nred-4";
  if (props.theme === "yellow") return "bg-nyellow-4";
  return "";
});
</script>

<template>
  <div data-testid="bannerMessage" class="flex w-full justify-center items-center py-2" :class="containerClasses">
    <button v-if="dismissible" type="button" :aria-label="$t('buttons.close')" @click="$emit('close')">
      <base-icon name="mdi:window-close" size="12px" class="absolute top-[10px] right-[10px]" />
    </button>
    <span v-if="theme === 'readOnly'" class="text-xs text-ngray-2 font-normal inline-flex items-center">
      <IconCircleExclamationMark />
      {{ $t("desc.readOnlyPreview") }}
    </span>
    <slot></slot>
  </div>
</template>
